import { Box, Button, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ModalWrapper } from 'src/components/modal-wrapper'

import { useStyles } from './../styles'
import { IUpdateSettingsImagesPayloadDto } from 'src/types'

interface IProps {
  image: IUpdateSettingsImagesPayloadDto
  onSave: (newImage: IUpdateSettingsImagesPayloadDto) => void
  handleCloseModal: () => void
  open: boolean
  isLoading?: boolean
}

export const EditImageVariableModal = ({
  image,
  open,
  onSave,
  handleCloseModal,
  isLoading = false,
}: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  const [value, setValue] = useState(image?.value || '')

  useEffect(() => {
    if (image) {
      setValue(image.value)
    }
  }, [image])

  const handleSave = () => {
    onSave({ field: image?.field, value: value })
  }

  return (
    <ModalWrapper className={classes.modalWrapper} open={open} onClose={handleCloseModal}>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          gap: '20px',
          width: '100%',
          flexDirection: 'column',
          justifyContent: 'space-between',
          pt: '30px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            gap: '10px',
          }}
        >
          <TextField
            variant="outlined"
            fullWidth
            size="small"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            disabled={isLoading}
            multiline
            maxRows={12}
            minRows={6}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: '25px',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button variant="outlined" size="small" onClick={handleCloseModal} disabled={isLoading}>
            {t('cancel-button-text.v')}
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={handleSave}
            disabled={isLoading || value === image?.value}
          >
            {t('save-button-text.v')}
          </Button>
        </Box>
      </Box>
    </ModalWrapper>
  )
}
